import { defineComponent } from 'vue';
export default defineComponent({
    name: 'FilterList',
    props: {
        taxonomy: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        terms: {
            type: Array,
            required: true,
        },
        selectedTerms: {
            type: Set,
            required: true,
        },
        toggleCb: {
            type: Function,
            required: false,
        },
        fullOpen: {
            type: Boolean,
            default: false,
        },
        depth: {
            type: Number,
            default: 1,
        },
        maxDepth: {
            type: Number,
            default: null,
        },
        universalTermId: {
            type: String,
            required: false,
        },
        showImage: {
            type: Boolean,
            default: false,
        },
        teleport: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            isMoved: false,
        };
    },
    computed: {
        displayTitle() {
            if (this.title === null)
                return null;
            const titleLower = this.title.toLowerCase();
            if (titleLower === 'linee' || titleLower === 'lines')
                return 'Filtri rapidi';
            return this.title;
        },
        termsToIter() {
            if (this.universalTermId === undefined) {
                return this.terms;
            }
            const terms = [];
            for (const t of this.terms) {
                if (t.id === this.universalTermId) {
                    continue;
                }
                terms.push(t);
            }
            return terms;
        },
    },
    mounted() {
        if (this.isMoved) {
            return;
        }
        const tp = this.teleport;
        if (tp === undefined) {
            return;
        }
        const destination = document.querySelector(tp);
        if (destination === null) {
            console.warn(`Teleport destination element ${tp} does not exists. Skipping`);
            return;
        }
        if (this.$refs.filter) {
            destination.appendChild(this.$refs.filter);
            this.isMoved = true;
        }
    },
    methods: {
        handleChange(e, term) {
            const checked = e.target.checked;
            if (this.toggleCb === undefined)
                return;
            this.toggleCb(this.taxonomy, term, checked);
        },
        image(term) {
            return (term.image?.sizes['woocommerce_thumbnail']?.link ??
                term.image?.link);
        },
    },
});
